const N = 11;
export {
  N as PPN_IN_PERCENT
};
